import React from "react";
import { Zap, Mail, Phone, MapPin, Linkedin, Twitter, Github } from "lucide-react";
import { services, contactInfo } from "../../data/mock";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="relative pt-20 pb-8 overflow-hidden border-t border-cyan-400/10" style={{ background: "linear-gradient(180deg, #050818 0%, #030510 100%)" }}>
      <div className="orb bg-blue-600/10 w-[520px] h-[520px] top-[-200px] left-[-160px]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-sky-500 to-cyan-400 blur-md opacity-60" />
                <div className="relative w-11 h-11 rounded-xl bg-gradient-to-br from-sky-500 to-cyan-400 flex items-center justify-center">
                  <Zap className="w-6 h-6 text-white" strokeWidth={2.5} />
                </div>
              </div>
              <div>
                <div className="font-display font-bold text-white text-lg">FortressPoint</div>
                <div className="text-[11px] tracking-widest uppercase text-cyan-300/80">{t("footer.technologySolutions")}</div>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">{t("footer.tagline")}</p>
            <div className="mt-6 flex items-center gap-3">
              {[Linkedin, Twitter, Github].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-lg border border-white/10 hover:border-cyan-400/40 hover:bg-cyan-500/10 flex items-center justify-center transition text-slate-300 hover:text-cyan-300">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-widest text-cyan-300 font-semibold mb-4">{t("footer.servicesTitle")}</div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 text-sm">
              {services.slice(0, 8).map((s) => {
                const title = t(`services.items.${s.slug}.title`) || s.title;
                return (
                  <li key={s.slug}>
                    <a href={`/services/${s.slug}`} className="text-slate-300 hover:text-cyan-300 transition">{title}</a>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-widest text-cyan-300 font-semibold mb-4">{t("footer.contactTitle")}</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-slate-300">
                <Mail className="w-4 h-4 mt-0.5 text-cyan-300" />
                <div className="flex flex-col">
                  {contactInfo.emails.map((e) => <a key={e} href={`mailto:${e}`} className="hover:text-cyan-300">{e}</a>)}
                </div>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Phone className="w-4 h-4 text-cyan-300" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-cyan-300">{contactInfo.phone}</a>
              </li>
              <li className="flex items-start gap-3 text-slate-300">
                <MapPin className="w-4 h-4 mt-0.5 text-cyan-300" />
                <div>{contactInfo.address.join(", ")}</div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} FortressPoint IT Solutions. {t("footer.rights")}
          </div>
          <div className="flex items-center gap-5 text-xs text-slate-500">
            <a href="#" className="hover:text-cyan-300">{t("footer.privacy")}</a>
            <a href="#" className="hover:text-cyan-300">{t("footer.terms")}</a>
            <a href="#" className="hover:text-cyan-300">{t("footer.sitemap")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
